<template>
  <vs-row class="p-3 mt-2 shadow-sm bg-white">
    <vs-col vs-lg="7">
      <vs-row>
        <vs-col vs-lg="3">
          <vs-chip @click.native="copyEmailToClipboard(item.id)">
            <vs-avatar
              :icon="
              item.estado === 'sended' ? 'check' :
              item.estado === 'error' ? 'error' :
              item.estado === 'empty' ? 'error' :
              'timer'
              "
              :color="
              item.estado === 'sended' ? 'green' :
              item.estado === 'error' ? 'red' :
              item.estado === 'empty' ? 'orange' :
              'gray'
              "
            />
            {{ item.application }}
          </vs-chip>
        </vs-col>
        <vs-col vs-lg="4">
          <vs-chip @click.native="copyEmailToClipboard(item.empresa)">
            <vs-avatar
              :icon="'fingerprint'"
              :color="'gray'"
            />
            {{ item.empresa }}
          </vs-chip>
        </vs-col>
        <vs-col vs-lg="4" class="text-truncate">
          <vs-chip @click.native="copyEmailToClipboard(sender)">
            <vs-avatar
              :icon="'send'"
              :color="'gray'"
            />
            {{ sender }}
          </vs-chip>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-lg="3">
          <vs-chip @click.native="copyEmailToClipboard(item.servicio)">
            <vs-avatar
              :icon="'extension'"
              :color="'gray'"
            />
            {{ item.servicio }}
          </vs-chip>
        </vs-col>
        <vs-col vs-lg="4">
          <vs-chip @click.native="copyEmailToClipboard(localTimestamp)">
            <vs-avatar
              :icon="'event'"
              :color="'gray'"
            />
            {{ localTimestamp | dateFormatDateTime }}
          </vs-chip>
        </vs-col>
        <vs-col vs-lg="4" class="text-truncate">
          <vs-chip
            v-for="destinatario in item.destinatarios"
            @click.native="copyEmailToClipboard(destinatario)"
            :key="destinatario"
          >
            <vs-avatar
              icon="email"
            />
            {{ destinatario }}
          </vs-chip>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="4">
      {{ item.subject }}
    </vs-col>
    <vs-col vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center">
      <Options
        :item="item"
      />
    </vs-col>
  </vs-row>
</template>
<script>

import Options from './Options';

export default {
  name: 'ListRow',
  components: {
    Options
  },
  data() {
    return {};
  },
  computed: {
    localTimestamp() {
      return new Date(`${this.item.timestamp}Z`);
    },
    sender() {
      const regex = /<([^>]+)>/; // Expresión regular para extraer lo que está entre "<" y ">"
      const coincidencia = regex.exec(this.item.sender);
      if (coincidencia && coincidencia.length > 1) {
        return coincidencia[1];
      }
      return this.item.sender;
    }
  },
  watch: {},
  methods: {
    copyEmailToClipboard(...args) {
      const text = args.join(' ');
      navigator.clipboard.writeText(text);
      this.$bvToast.toast(
        `Se ha copiado: ${text}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true
        }
      );
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style scoped>
.loadData {
  height: 80vh;
}
</style>
